'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".Divider-module_hr__Ej0Np{border:none;border-bottom:1px solid #e0e0e0}";
var styles = {"hr":"Divider-module_hr__Ej0Np"};
styleInject["default"](css_248z, '65de067f-6427-4474-9bfa-181d28a806cf');

exports["default"] = styles;
